import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Box = styled.div`
padding-top: 24px;

ul {
	padding-inline-start: 16px !important;
}
`;

const Title = styled.div`
padding: 8px 12px;
	margin-bottom: 16px;
	background: linear-gradient(90deg, rgba(255, 214, 71, 0.00) 0%, #FFD647 50%, rgba(255, 214, 71, 0.00) 100%);
	backdrop-filter: blur(25px);

	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	color: #2A2A2A;
	text-align: center;
`;

const Text = styled.div`
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #2A2A2A;
	text-align: left;
`;

const TermsConditions = ({ title, rule }) => {
	const { t } = useTranslation();

	return (
		<Box>
			<Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
			<Text dangerouslySetInnerHTML={{ __html: rule }} />
		</Box>
	);
};

export default TermsConditions;
